export const NAVIGATION_LINKS = [
  { title: "SUBSCRIBE", href: "https://mindfully.art/contact-details" },
  { title: "DONATE", href: "https://buymeacoffee.com/illumex" },
  { title: "INSIGHT", href: "https://mindfully.art" },
];
